module.exports = __webpack_public_path__ + "img/tagsImg.282fc774.png";